import {
  Component,
  OnInit,
  NgZone,
  ViewChild,
  AfterViewInit,
} from "@angular/core";
import {
  ActionSheetController,
  AlertController,
  ModalController,
  LoadingController,
  NavParams,
  IonContent,
} from "@ionic/angular";
import { Router } from "@angular/router";
import { SharedService } from "src/app/Services/sheared/sharedService.service";
import { CotationAutoService } from "src/app/Services/Cotation/cotationAuto.service";
import { AssureurService } from "src/app/Services/Assureur/assureur.service";
import { authenticationService } from "src/app/Services/Authentication/authentication.service";
import { FactoryService } from "src/app/Services/historique/factory.service";
import { Camera, PictureSourceType } from "@ionic-native/camera/ngx";
import { PaiementService } from "src/app/Services/Paiement/paiement.service";
import { File, FileEntry } from "@ionic-native/file/ngx";
import {
  BackgroundMode,
  BackgroundModeConfiguration,
} from "@ionic-native/background-mode/ngx";

@Component({
  selector: "app-autoresumeprime",
  templateUrl: "./autoresprime.component.html",
  styleUrls: ["./autoresprime.component.scss"],
})
export class AutoResPrimeComponent implements OnInit, AfterViewInit {
  options = {
    centeredSlides: true,
    loop: false,
    spaceBetween: -50,
  };
  dtjr: string;
  objetpass: any;
  itemsData: any[];
  private items: any[] = [];
  select_Assureur: any = null;
  assureurs = [];
  selectedImage: string = "";
  fileList: string[] = [];
  textImageselect: boolean;
  isEnabled: boolean = false;
  TypeObjet: string = "";
  afficheVoyage: boolean = false;
  loading: HTMLIonLoadingElement;
  vehicule: any;
  percent: number;
  private imagetest;
  skeleton_go:boolean
  @ViewChild(IonContent, { static: false }) content: IonContent;
  // options = {
  //   slidesPerVieW:1.5
  // };

  constructor(
    private modalCtrl: ModalController,
    private assureurService: AssureurService,
    private _sheard: SharedService,
    private auth: authenticationService,
    private actionSheetCtrl: ActionSheetController,
    private camera: Camera,
    private alertController: AlertController,
    private loadingController: LoadingController,
    private _fact: FactoryService,
    private _cotationAutoService: CotationAutoService,
    private _primeService: PaiementService,
    private _route: Router,
    private ngZ: NgZone,
    private nvparms: NavParams,
    private file: File,
    private backgroundMode: BackgroundMode
  ) {
    this.assureurService.getAssureurs();
    //   this.backgroundMode.on('activate').subscribe(() => {
    //     // Call your method here
    //     debugger
    //     this.cropImage(this.imagetest)

    // });

    // this.backgroundMode.enable();

    this.objetpass = this.nvparms.get("value");
    this.objetpass.CodeAssur = this._fact.getData(201);

    this.vehicule = this._fact.getData(150);

    this.dtjr = this._sheard.ConvertDMYorYMD(this._sheard.getDate());

    let data = [];
    //POUR MONTRER QUE LA DONNEE EST DE L'AUTOMOBILE
    this.TypeObjet = "AUTOMOBILE";

    this.selectedImage = "../../../assets/img/placeholder.jpg";

    this.assureurService.ListAssreurs.subscribe((res) => {
      try {
        this.assureurs = res;
      } catch (error) {}
    });
    this.skeleton_go=false
  }
  ngAfterViewInit(): void {
    // console.log( this.objetpass);
  }

  ionViewDidEnter() {}
  ngOnInit(): void {
    let timer = setTimeout(() => {
      let itemsDataInit = [];
      if (this.objetpass.mois12) {
        itemsDataInit.push({
          periode: this.objetpass.mois12,
          prime: this.objetpass.prime12,
          accessoire: this.objetpass.acc12,
          taxe: this.objetpass.Taxe12,
          css: this.objetpass.css12,
          carterose: this.objetpass.cartRose12,
          tvl: this.objetpass.Tvl12,
          primettc:
            this.objetpass.prime12 +
            this.objetpass.acc12 +
            this.objetpass.Taxe12 +
            this.objetpass.css12 +
            this.objetpass.cartRose12 +
            this.objetpass.Tvl12 +
            1000,
          constatAm: 1000,
          type: "AUTOMOBILE",
          open: false,
        });
      }
      if (this.objetpass.mois6) {
        itemsDataInit.push({
          periode: this.objetpass.mois6,
          prime: this.objetpass.prime6,
          accessoire: this.objetpass.acc6,
          taxe: this.objetpass.Taxe6,
          css: this.objetpass.css6,
          carterose: this.objetpass.cartRose6,
          tvl: this.objetpass.Tvl6,
          primettc:
            this.objetpass.prime6 +
            this.objetpass.acc6 +
            this.objetpass.Taxe6 +
            this.objetpass.css6 +
            this.objetpass.cartRose6 +
            this.objetpass.Tvl6 +
            1000,
          constatAm: 1000,
          type: "AUTOMOBILE",
          open: false,
        });
      }
      if (this.objetpass.mois3) {
        itemsDataInit.push({
          periode: this.objetpass.mois3,
          prime: this.objetpass.prime3,
          accessoire: this.objetpass.acc3,
          taxe: this.objetpass.Taxe3,
          css: this.objetpass.css3,
          carterose: this.objetpass.cartRose3,
          tvl: this.objetpass.Tvl3,
          primettc:
            this.objetpass.prime3 +
            this.objetpass.acc3 +
            this.objetpass.Taxe3 +
            this.objetpass.css3 +
            this.objetpass.cartRose3 +
            this.objetpass.Tvl3 +
            1000,
          constatAm: 1000,
          type: "AUTOMOBILE",
          open: false,
        });
      }
      this.itemsData = itemsDataInit;
      clearTimeout(timer);
    }, 100);

    this._fact.seTtracking(
      new Date().toISOString(),
      "L7",
      false,
      "1000",
      "",
      "Prime Auto",
      ""
    );
  }
  private uploadingAuto($key: string, police) {
    //this.vehicule = this._fact.getData(150);

    let auto: any = {
      libelle_cat: this.vehicule.Libelle_Categorie,
      place: this.vehicule.place,
      puiss: this.vehicule.puiss,
      ener: this.vehicule.energ,
      immat: this.vehicule.immat,
      nomprop: this.vehicule.nomprop,
      prenomprop: this.vehicule.prenpro,
      emailprop: this.vehicule.emailprop,
      garanties: this.vehicule.garantie,
      telprop: this.vehicule.telpro,
      securiteRoutiere: this.vehicule.securiteRoutiere,
      dateEffet: this.vehicule.dateEffet,
      dateExpi: this.objetpass.dateExpi,
      complement_Prime: this.objetpass[0],
      valneuf:
        typeof this.vehicule.valNeuf === "undefined"
          ? 0
          : this.vehicule.valNeuf,
      valvenale:
        typeof this.vehicule.valVenale === "undefined"
          ? 0
          : this.vehicule.valVenale,
      carteURL: this.vehicule.cartegrise,
      Police: police,
      cartePath: this.vehicule.cartePath,
      dateInsert: this._sheard.getTimeStampFromToday(), //,
      icon: this.vehicule.icon, //"../../../assets/icon/car-sport.svg"
    };

    //#region Ancienne méthode
    this._fact.seTtracking(
      new Date().toISOString(),
      "L8",
      false,
      "1000",
      "",
      "Enregistre_simul_auto",
      police
    );

    this._cotationAutoService
      .instNewAuto(auto, this.objetpass.CodeAssur, $key)
      .then(() => {
        this.loading.dismiss().then((res) => {
          if (res) {
            this.modalCtrl.dismiss().then((res) => {
              if (res) {
                auto = {};
                this.selectedImage = "";
                try {
                  this.modalCtrl.dismiss();
                } catch (error) {}

                this._cotationAutoService.delete_image_load();
                setTimeout(() => {
                  this.ngZ.run(() => {
                    this._route
                      .navigateByUrl("prime/30", { replaceUrl: true })
                      .finally(() => {
                        this._cotationAutoService.items_imguploaded_auto = [];
                      });
                  });
                });
              }
            });
          }
        });
      });

    //#endregion
  }
  PayerPrimer() {
    this.controlDeProvenance(this.TypeObjet);
  }

  private async controlDeProvenance(_objet: any = null) {
    this.loading = await this.loadingController.create({
      message: "Envoi en cours...",
      // duration: 60 * 1000,
      mode: "ios",
      spinner: "bubbles",
    });
    await this.loading.present();
    this._fact.setData(30, []);
    //this.objetpass.cartegrise = this.selectedImage;

    //#region AUTOMOBILE
    let duree = 0;
    if (this.objetpass[0].periode == "3 mois") {
      duree = 90;
    } else if (this.objetpass[0].periode == "6 mois") {
      duree = Math.round(this._sheard.DayOfyear(new Date()) / 2);
    } else {
      duree = Math.round(this._sheard.DayOfyear(new Date()));
    }

    let police = `AUTO-${this._sheard.generatorPolice()}`;
    this.items = [];

    this.items.push({
      NumPolice: police,
      police: police,
      NomPrenom: this.auth.profile.NomPrenom,
      Notification: "",
      CodeAssur: this.objetpass.CodeAssur,
      NumRef: "",
      dateEffet: this.vehicule.dateEffet,
      dateExpi: this.objetpass.dateExpi,
      montant_due: this.objetpass[0].primettc,
      Immat: this.vehicule.immat,
      montant_paye: 0,
      date_paiement: "",
      dateInsert: this._sheard.getDate(),
      etatdoc: "",
      icon: "../../../assets/icon/car-sport.svg",
      flag: false,
      //isChecked:true,

      notifydoc: false,
      notify: true,
      CodeMvt: "AFN",
      duree: duree,
      mode_paie: "",
      numClient: "",
      solde: false,
      type: "Auto",
      //idkeyPar:"",
      idKey: this.auth.profile.uid,
    });
    // this._fact.setData(30,this.items[0])
    this._primeService.insertPrime(this.items).then((res) => {
      this.items[0].$key = res.key;
      this.items[0].nbPaie = 0;
      this.items[0].montantVerse = 0;
      this.items[0].montant_restant = this.objetpass[0].primettc;

      this._fact.setData(30, this.items[0]);
      // if (isUndefined(this.objetpass.CodeAssur)) {
      //   this._primeService.addQuit(res.key,this.objetpass.CodeAssur)
      // }
      this.uploadingAuto(res.key, police);
    });

    //#endregion
  }
  onValider(item) {
    //this.objetpass.cartegrise=this.selectedImage
    this.presentPayment(item);
  }
  onDetail(item) {
    item.open = !item.open;
  }
  private async presentPayment(nameSelected) {
    
    let dateEffet = this.vehicule.dateEffet.split("-").reverse().join("-");
    //this._sheard.getDateWithTimeDMY();
    let jrs;
    let dateExpi;
    // this._sheard.TimeStampToformatDMY(this._sheard.getTimeStampFromToday())
    if (nameSelected.periode == "3 mois") {
      dateExpi = this._sheard.ConvertDMYorYMD(
        this._sheard.getDate(
          this._sheard.AddDays(/*this._sheard.getDate()*/ dateEffet, 89)
        )
      );
    } else if (nameSelected.periode == "6 mois") {
      dateExpi = this._sheard.ConvertDMYorYMD(
        this._sheard.getDate(
          this._sheard.AddDays(
            // this._sheard.getDate(),
            dateEffet,
            Math.round(this._sheard.DayOfyear(new Date()) / 2) - 1
          )
        )
      );
    } else if (nameSelected.periode == "12 mois") {
      dateExpi = this._sheard.ConvertDMYorYMD(
        this._sheard.getDate(
          this._sheard.AddDays(
            dateEffet,
            this._sheard.DayOfyear(new Date()) - 1
          )
        )
      );
    }

    const alert = await this.alertController.create({
      header: "Enregistrement de la prime",
      mode: "ios",
      message:
        "Vous avez choisi une couverture d'une durée de <strong>" +
        nameSelected.periode +
        "</strong>. Ce contrat d'assurance prendra donc effet à :" +
        "<p style='margin-left: -27px;'>*Date effet : <strong>" +
        this.vehicule.dateEffet +
        "</strong></p>" +
        "<p>*Date expiration : <strong>" +
        dateExpi +
        "</strong></p>" +
        "<p><strong>NB:</strong> Si vous reportez le paiement de la prime à un autre jour, " +
        "la date d'effet du contrat sera la date de paiement. </p><br>",
      cssClass: "",
      buttons: [
        {
          text: "Annuler",
          role: "cancel",
          cssClass: "primary",
          handler: () => {
            //this._objet = "Selectionner l'objet"
          },
        },
        {
          text: "OK",
          handler: () => {
            this.objetpass = this.itemsData = this.itemsData.filter(
              (e) => e.periode == nameSelected.periode
            );
            this.textImageselect = true;
            this.objetpass.dateExpi = dateExpi;
            this.objetpass.duree = nameSelected.periode;

            setTimeout(() => {
              this.content
                .scrollToBottom(800)
                .then
                //() => this.affiche=true
                ();
              // $("#mytext").focus();
            });
          },
        },
      ],
    });
    await alert.present();
  }

  async selectSource(typeimg: string) {
    const actionSheet = await this.actionSheetCtrl.create({
      mode: "ios",
      header: "Photo",
      cssClass: "actshhetCss",
      buttons: [
        {
          text: "Galerie photo",
          icon: "images-outline",
          handler: () => {
            this.getPicture(
              this.camera.PictureSourceType.PHOTOLIBRARY,
              typeimg
            );
          },
        },
        {
          //icon:"../../../../assets/icon/camera-outline.svg",
          text: "Capture image",
          icon: "camera-outline",
          handler: () => {
            this.getPicture(this.camera.PictureSourceType.CAMERA, typeimg);
          },
        },
        {
          text: "Annuler",
          icon: "close-circle-outline",
          role: "cancel",
        },
      ],
    });
    await actionSheet.present();
  }

  private getPicture(sourceType: PictureSourceType, typeimg: string) {
    //Launch the skeleton
    this.skeleton_go=true
    this.camera
      .getPicture({
        quality: 100,
        destinationType: this.camera.DestinationType.FILE_URI,
        sourceType: sourceType,
        mediaType: this.camera.MediaType.PICTURE,
        encodingType: this.camera.EncodingType.JPEG,
        allowEdit: true,
        // targetWidth:1000,
        // targetHeight:1000,
        saveToPhotoAlbum: true,
        correctOrientation: true,
      })
      .then(async (imageData) => {
        this.resizeimage(imageData);
      })
      .catch((err) => {
        this.skeleton_go=false
      });
  }

  /*--------------------------------------
2022-02-16T 18:32:30.000-05:00
-----------------------------------------*/
  private readfile(file) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const that = this;
    this.skeleton_go=false
    reader.onload = function (event) {
      // Resize image to max wdth or height of 300 pixels

      const imgElment = document.createElement("img");
      imgElment.src = event.target.result as string;
      
      // const taille=that._cotationAutoService.calculateImageSize(imgElment.src.split(',')[1])
      imgElment.onload = function (e) {
        var MAX_WIDTH = 400;
        var MAX_HEIGHT = 700;

        var width = imgElment.width;
        var height = imgElment.height;

        // Change the resizing logic
        if (width > height) {
          if (width > MAX_WIDTH) {
            height = height * (MAX_WIDTH / width);
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width = width * (MAX_HEIGHT / height);
            height = MAX_HEIGHT;
          }
        }

        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(imgElment, 0, 0, canvas.width, canvas.height);
        var dataurl = canvas.toDataURL(file.type);
        that.selectedImage = dataurl;
        that.upload_image();
        //const taille=that._cotationAutoService.calculateImageSize(dataurl.split(',')[1])
        
      //  const timer= setTimeout(() => {
          
      //   });
          const elm = document.getElementById("preview") as HTMLImageElement;
          elm.src = dataurl;
          //clearTimeout(timer)
          that.desactiveBtn();
      };
    };
  }

  private async upload_image() {
    this.loading = await this.loadingController.create({
      message: "Traitement de l'image en cours...",
      // duration: 60 * 1000,
      mode: "ios",
      spinner: "lines-small",
    });
    await this.loading.present();
    this._cotationAutoService
      .uploadFile(
        this.selectedImage,
        "Automobiles",
        this.vehicule,
        this.loading
      )
      .subscribe(
        (percent) => {
          this.percent = Math.round(percent ? percent : 0);
          // this.objetpass
        },
        (error) => {
          console.error(error);
        }
      );
  }

  private resizeimage(ImagePath) {
    if (!ImagePath) return;
    this.file.resolveLocalFilesystemUrl(ImagePath).then((entry: FileEntry) => {
      entry.file((file) => {
        this.readfile(file);
      });
    });
  }

  private desactiveBtn() {
    this.isEnabled = false;
    this.objetpass.CodeAssur = this._fact.getData(201);
    if (this.objetpass.CodeAssur) {
      if (this.selectedImage !== "../../../assets/img/placeholder.jpg")
        this.isEnabled = true;
    }
  }
}
